<template>
  <div class="material">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">取扱素材</h1>
        </div>
				<p>
扱う素材の一部を掲載しています。未記載素材についてはお問い合わせください。
				</p>
      </div>
    </div>

		<div v-show="checkHideContents(SecondLayer)">
			<div class="container">
				<div class="rowView">
					<sort-panel @parentMethod="updateList" :origin=originList :page-range="50" :page-num=currentPage :list-header="setListHeader" v-if="setListPanel"></sort-panel>
					<any-list @createDetail="createDetail" :display-list="displayList" :any-list="4"></any-list>
				</div>

				<section class="tips tagJumpTarget" id="MaterialPrice">
					<div class="container">
						<div class="rowView">
							<h2>Tips</h2>
							<div class="noteContent">
								<p>
最新の鋼材価格は以下のページを参照ください。
								</p>
								<p>
<a href="https://www.japanmetal.com/iron-steel-price" target="_blank" rel=”nofollow” class="externalLink"> 産業新聞 鉄鋼市場価格</a>
								</p>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>

		<router-view v-on:changeDetail="setDetail"></router-view>
  </div>
</template>

<script>
import sortPanel from '@/components/SortPanel.vue'
import anyList from '@/components/AnyList.vue'
//const originList = require('@/../public/asset/data/material.json')

export default {
  name: 'material',
  components:{
    sortPanel, 
		anyList,
  },
  data: function () {
    return {
      originList:[],
      displayList:[],
			currentPage:1,
      detailIndex:0,
			listHeader:[
{title:"JIS", element:"note"},
{title:"名称", element:"title"},
{title:"材質", element:"material"},
{title:"状態/性質/用途", element:"remarks"},
{title:"単価目安", element:"budget"},],
			pageTitle:"取扱素材",
			description:"豊嶋精密工業株式会社で扱う素材の一部です。未掲載素材はお尋ねください。",
			keywords:"金属素材",
			ogType:"article",
		}
  },
  computed: {
		setListHeader:function() {
			return this.listHeader
		},
		setListPanel:function() {
/*直呼び出しの場合、jsonが揃ってから構築しないと、再構築してくれない。*/
			return this.originList.length > 0
		}
	},
  beforeMount:function() {console.log("beforeMount "+this.$options.name)
//ページ初期構築時の情報をセットする
    this.setList()
			if(this.$route.query.list) {
				this.currentPage = Number(this.$route.query.list)
			}
  },
  mounted: function() {console.log("mounted "+this.$options.name)
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/business/material?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
  beforeUpdate:function() {console.log("beforeUpdate "+this.$options.name)
		if(this.$route.query.list) {
/*ブラウザーボタン処理変化の場合は、urlに合わせたリスト表示を更新する必要がある*/
			let aPageNumber = Number(this.$route.query.list)
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
			}
		} else {
				this.currentPage = 1
		}
	},
  updated:function() {console.log("updated "+this.$options.name)

    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/business/material?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

  },
  methods:{
    createDetail(aImg, index){
/*
      this.detailIndex = index
      this.$router.push({
          name: '設備詳細',
          params: { 
              pageId:aImg.title,
              anyList:1,
              detail:aImg,
          }
      })
*/
    },
    setDetail:function(aFor) {
/*
      this.detailIndex += aFor
      if(this.displayList.length <= this.detailIndex) {
        this.detailIndex = 0
      } else if(this.detailIndex < 0 ) {
        this.detailIndex = this.displayList.length-1
      }
      let aImg = this.displayList[this.detailIndex]
      this.$router.push({
          name: '設備詳細',
          params: { 
              pageId:aImg.title,
              anyList:1,
              detail:aImg
          }
      })
*/
    },
    setList() {
			if(this.$store.getters.originListMaterial.length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.$store.watch(
					(state, getters) => getters.originListMaterial,
					(newValue, oldValue) => {
						console.log('prefecture changed! %s => %s', oldValue, newValue)
						this.originList = this.$store.getters.originListMaterial
						this.resetList()
					}
				)
			} else {
				this.originList = this.$store.getters.originListMaterial
				this.resetList()
			}
    },
    resetList() {
      this.displayList = Object.assign([], this.originList)
			this.orderList = Object.assign([], this.originList)
    },
    updateList(aDisplayList, aDisplayListAll, aPageNumber) {
/*子から呼び出す表示更新メソッド*/
      this.displayList = aDisplayList
			this.orderList = aDisplayListAll
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
				this.$router.push({
          name: '取扱素材',
          query: { 
              list:aPageNumber,
          }
				})
			}
    },
  },
}
</script>


<style>
</style>
